module.exports = __webpack_public_path__ + "img/send_button_black.89edf81f.svg";